const PRODUCT_STORAGE_NAME = 'productIdForEligibilityChecker';

const productIdStorage = {
  save() {
    const productId = window.digitalData.product[0].productID;
    sessionStorage.setItem(PRODUCT_STORAGE_NAME, productId);
  },
  load() {
    const productId = sessionStorage.getItem(PRODUCT_STORAGE_NAME);
    return productId;
  },
  remove() {
    sessionStorage.removeItem(PRODUCT_STORAGE_NAME);
  }
};
export default productIdStorage;
